/*
 * Copyright (c) 2024, Behçet Atalay
 * All rights reserved.
 *
 * @project   kaan-web
 * @author    Behçet Atalay
 * @site      https://www.technobecet.com
 * @date      18 February 2024
 */

import TextFeaturePanel from '../Components/TextFeaturePanel';
import Portfolio from '../Components/Portfolio';

const Projects = () => {
  return (
    <div className='mx-auto'>
      <TextFeaturePanel />
      <Portfolio />
    </div>
  );
};

export default Projects;
